import Collection from "../../data-structures/collection"
import Condition from "./condition"
import ModelEntity from "../model-entity"
import {ConditionsToJsonParams} from "./@types"

export enum ConditionsLogicalOperator {
    AND = 'AND',
    OR  = 'OR',
}

export type ConditionsConfig = {
    logicalOperator     : ConditionsLogicalOperator,
    conditions          : any[]
}

// const debug = "ConditionsCollection"
const debug = false

export default class ConditionsCollection extends Collection<Condition> {

    public logicalOperator: ConditionsLogicalOperator

    constructor(logicalOperator: ConditionsLogicalOperator, models: Condition[]) {
        super(models)

        this.logicalOperator = logicalOperator
    }

    private generateId():ID {
        return gd.utils.generateUIDWithCollisionChecking(this.ids)
    }

    public addEmptyCondition() {
        this.add(new Condition({
            id: this.generateId()
        }))
    }

    static initFromConfig(conditionsConfig?: ConditionsConfig): ConditionsCollection {
        if (!conditionsConfig) {
            return new ConditionsCollection(ConditionsLogicalOperator.AND, [])
        }

        return new ConditionsCollection(
            _.get(conditionsConfig, 'logicalOperator', ConditionsLogicalOperator.AND),
            _.map(conditionsConfig.conditions, conditionJson=>new Condition(conditionJson)),
        )
    }

    add(model: Condition | null) {
        // generate id if model don't have it
        if (model && !model.id) {
            model.id = this.generateId()
        }

        super.add(model)
    }

    exportToForm(): {
        logicalOperator : ConditionsLogicalOperator,
        conditions      : JSONArray
    } {
        return {
            logicalOperator : this.logicalOperator,
            conditions      : _.map(this.models, model=>model.toJSON()) as JSONArray
        }
    }

    areMetBy(model: ModelEntity): boolean {
        let res = true

        switch (this.logicalOperator) {
            case ConditionsLogicalOperator.AND:
                // if at least one condition does NOT fit model result would be false
                res = !_.some(this.models, condition=>!condition.isMetBy(model))
                break

            case ConditionsLogicalOperator.OR:
                // if at least one condition fits model result would be true
                res = _.some(this.models, condition=>condition.isMetBy(model))
                break
        }

        return res
    }

    toJSON(params: ConditionsToJsonParams = {}):JSONObject|null {
        debug && console.log(debug, "toJSON()", this.models)

        const notEmptyModels = _.filter(this.models,(condition:Condition)=>{
            return !condition.isEmpty
        })

        if (notEmptyModels.length<1) {
            return null
        }

        const result:any = {
            logicalOperator : this.logicalOperator,
            conditions      : _.map(notEmptyModels, model=>model.toJSON(params))
        }

        debug && console.log("    result", result)

        return result
    }
}